interface Props {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: "left" | "center";
  tone?: "light" | "dark";
}

export function SectionHeader({ eyebrow, title, subtitle, align = "left", tone = "light" }: Props) {
  const isDark = tone === "dark";
  return (
    <div className={align === "center" ? "mx-auto max-w-3xl text-center" : "max-w-3xl"}>
      {eyebrow && (
        <div className={`mb-3 inline-flex items-center gap-2 font-display text-xs tracking-[0.3em] ${isDark ? "text-accent" : "text-primary"}`}>
          <span className={`h-px w-8 ${isDark ? "bg-accent" : "bg-primary"}`} />
          {eyebrow}
        </div>
      )}
      <h2 className={`font-display text-4xl leading-[0.95] md:text-5xl lg:text-6xl ${isDark ? "text-secondary-foreground" : "text-foreground"}`}>
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-base md:text-lg ${isDark ? "text-secondary-foreground/75" : "text-muted-foreground"}`}>{subtitle}</p>}
    </div>
  );
}
